import React from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

interface StepProps {
  showing: boolean
  children: JSX.Element
  verticalAlignment: 'start' | 'center' | 'end'
}

export default function Step(props: StepProps) {
  const {showing, verticalAlignment, children} = props
  return (
    <Box showing={showing} verticalAlignment={verticalAlignment}>
      <div
        className={classNames({
          'block-content': showing,
        })}
      >
        {children}
      </div>
    </Box>
  )
}

const Box = styled.div<{
  showing: boolean
  verticalAlignment: 'start' | 'center' | 'end'
}>`
  opacity: ${(props) => (props.showing ? 1 : 0)};
  visibility: ${(props) => (props.showing ? 'visible' : 'hidden')};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: ${(props) => props.verticalAlignment};
`
